"use client";

import { useEffect } from "react";

/**
 * Вход первого экрана (хедер, герой, футер) делает CSS-класс `.gl-enter`
 * (см. `app/globals.css`), а не framer-motion: анимация играет с первого кадра,
 * до гидратации, поэтому пустого экрана «одна кнопка на чёрном» больше нет.
 *
 * Этот гейт сохраняет старое поведение «вход проигрывается один раз за загрузку
 * страницы, а не на каждой клиентской навигации»: через ENTRANCE_WINDOW_MS на
 * <html> вешается `gl-entrance-done`, и правило `html.gl-entrance-done .gl-enter`
 * гасит анимацию для всех последующих монтирований.
 */

// Самая длинная входная последовательность: delay 0.8s + duration 0.4s.
const ENTRANCE_WINDOW_MS = 1400;

export function EntranceGate() {
  useEffect(() => {
    const html = document.documentElement;
    if (html.classList.contains("gl-entrance-done")) return;
    const id = window.setTimeout(
      () => html.classList.add("gl-entrance-done"),
      ENTRANCE_WINDOW_MS,
    );
    return () => window.clearTimeout(id);
  }, []);
  return null;
}
